import { render, staticRenderFns } from "./walmartText.vue?vue&type=template&id=e178cc1e&scoped=true"
import script from "./walmartText.vue?vue&type=script&lang=js"
export * from "./walmartText.vue?vue&type=script&lang=js"
import style0 from "./walmartText.vue?vue&type=style&index=0&id=e178cc1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e178cc1e",
  null
  
)

export default component.exports